import React, { useState, useEffect } from "react";
import { LinearProgress, Typography, Box } from "investira.react.components";

/**
 * Renderiza o componente LoadingMessages.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {boolean} props.loading - Propriedade `loading` do componente.
 * @param {*} props.messages - Propriedade `messages` do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const LoadingMessages = (props) => {
  const { loading, messages } = props;
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (!loading) {
      return;
    }

    const xInterval = setInterval(() => {
      setCurrentMessageIndex(
        (xPrevIndex) => (xPrevIndex + 1) % messages.length
      );
    }, 10000);

    return () => clearInterval(xInterval);
  }, [loading, messages.length]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <LinearProgress style={{ width: "100%" }} />
      <Typography variant="body1" style={{ marginTop: 16 }}>
        {messages[currentMessageIndex]}
      </Typography>
    </Box>
  );
};

export default LoadingMessages;
